// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/sass/helper/_variables.scss
// module id = CsAh
// module chunks = 65